import { render, staticRenderFns } from "./ClassifiedsEmptyState.vue?vue&type=template&id=6cda2f31&"
import script from "./ClassifiedsEmptyState.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedsEmptyState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports